import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { demoApi } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { RotateCcw, Loader2, ArrowRight } from "lucide-react";

export default function DemoBanner() {
  const { user } = useAuth();
  const [resetting, setResetting] = useState(false);

  if (!user?.is_demo) return null;

  const handleReset = async () => {
    setResetting(true);
    try {
      await demoApi.reset();
      window.location.reload();
    } catch (e) { console.error(e); }
    finally { setResetting(false); }
  };

  return (
    <div className="bg-amber-500/[0.06] border-b border-amber-500/15 px-4 py-2 flex items-center justify-between gap-4" data-testid="demo-banner">
      <div className="flex items-center gap-3">
        <Badge className="bg-amber-500/15 text-amber-400 border-amber-500/30 border text-[9px] font-mono shrink-0">DEMO MODE</Badge>
        <span className="text-xs text-slate-400">Sample business data loaded — Meridian & Co</span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button size="sm" variant="ghost" className="h-7 text-xs text-slate-500 hover:text-slate-300 gap-1"
          onClick={handleReset} disabled={resetting} data-testid="demo-banner-reset">
          {resetting ? <Loader2 className="w-3 h-3 animate-spin" /> : <RotateCcw className="w-3 h-3" />} Reset Demo
        </Button>
        <a href="/register" className="text-xs text-amber-400 hover:text-amber-300 flex items-center gap-1 font-semibold">
          Create Account <ArrowRight className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
}
